import { useState, useEffect } from "react"
import cx from "classnames"
import PlayLargeIcon from "../../../icons/PlayLargeIcon"
import playerData from "../utils/playerData"
import styles from "../styles/PlayAll.module.scss"

const PlayAll = ({ selectedRound }) => {
  const [songVersions, setSongVersions] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setSongVersions(playerData(selectedRound))
  }, [selectedRound])

  const handlePlayAll = () => {
    if (isLoading) return
    setIsLoading(true)
    // First load the playlist into the audio player
    const playlistEvent = new CustomEvent("load-playlist", {
      detail: { items: songVersions.map((sv) => JSON.parse(sv.playSerializer)) },
    })
    document.dispatchEvent(playlistEvent)

    // Then play the first song
    const songVersionDetail = {
      detail: JSON.parse(songVersions[0].playSerializer),
    }
    const playEvent = new CustomEvent("start-playlist", songVersionDetail)
    document.dispatchEvent(playEvent)

    setTimeout(() => setIsLoading(false), 700)
  }

  return (
    <button
      onClick={handlePlayAll}
      className={cx(styles.playAll, { [styles.disabled]: songVersions.length === 0 })}
    >
      <PlayLargeIcon />
    </button>
  )
}

export default PlayAll
